<template>
    <ul class="option-list">
        <li v-if="showReset" class="highlighted">
            <button v-on:click="resetActiveOption()" :class="{ active: curOptionId === undefined}" class="btn-image reset">
                <ImageLoader :src="resetOptionIcon"></ImageLoader>
                <span>{{ $t('optionfilter.resetOption') }}</span>
            </button>
        </li>
        <li v-for="option in options" :key="option.id" v-if="!option.hidden" :class="{ hidden: (activeOptions.indexOf(option.id) == -1), highlighted: option.highlighted }">
            <button class="btn-image" v-on:click="selectOption(option)"
                    :disabled="isDisabled(option.id)" :class="{ active: isActive(option.id)}">
                <ImageLoader :name="option.name" :src="option.icon"></ImageLoader>
                <span>{{ option.name }}</span>
            </button>
        </li>
    </ul>
</template>

<script>
  import loaderMixin from "@/mixins/loaderMixin";
  import ImageLoader from "./ImageLoader";

  export default {
    name: "OptionList",
    components: {ImageLoader},
    props: {
        'optionName': {
          type: String,
          required: true,
        },
        'showReset': {
          type: Boolean,
          required: false,
          default: false
        }
    },
    mixins: [loaderMixin],
    computed: {
      /**
       * get all available options for option type
       * @returns {array} option object list
       */
      options: function () {
        return this.$store.state[this.optionName];
      },
      /**
       * get all active options of current bun
       * @returns {array} option id list
       */
      activeOptions: function () {
        return this.$store.getters.activeOptions(this.optionName);
      },

      /**
       * get all filtered active options of current bun
       * @returns {array} option id list
       */
      activeFilteredOptions: function () {
        return this.applyFilter()
      },

      /**
       * get all filters which apply to current option type
       * @returns {array} option filter list
       */
      optionFilters: function () {
        return this.$store.getters.filterByOption(this.optionName);
      },

      /**
       * get currently active option id
       * @returns {int} id
       */
      curOptionId: function () {
        return this.curRecipe[this.optionName.slice(0, -1)].id;
      },

      resetOptionIcon: function () {
          return this.$store.state.resetOptionIcon;
      }
    },
    methods: {
      /**
       * check if given id is active or filtered out
       * @param id
       * @returns {boolean}
       */
      isDisabled: function (id) {
        // check if bun is set and a filter should be applied to current option
        if (this.activeOptions !== undefined) {
          // deactivate option which is not listed in the filter
          return !this.activeFilteredOptions.includes(id)
        } else {
          // keep option activated
          return false;
        }
      },

      /**
       * check if id is currently active
       * @param id
       * @returns {boolean}
       */
      isActive: function (id) {
        return (id === this.curOptionId);
      },

      /**
       * add selected option to current recipe
       * @param option
       */
      selectOption: function (option) {
        // make singular name
        let type = this.optionName.slice(0, -1);

        // check if option should be toggled
        if(option.id === this.curRecipe[type].id) {
            // reset active option
            this.resetActiveOption();
        } else {
          // commit option change
          this.$store.commit('selectOption', {type, option});
        }
      },

      /**
       * apply all filters which are active for option type
       * @returns {array} active options id list
       */
      applyFilter: function () {
        // does a filter apply to current list and has any active items
        if ((this.optionFilters.length > 0) && (this.activeOptions.length > 0)) {
          // loop filters
          for (let i in this.optionFilters) {
            // fetch current filter
            let filter = this.optionFilters[i]

            // get option name (singular form)
            let optionName = filter.if.optionType.slice(0, -1);


            if (
                // deactivate all 'if' condition  '*' (all) matches
                ((filter.if.conditions === '*')
                    && (Object.keys(this.curRecipe[optionName]).length > 0) // ensure option obj is given
                    && (this.curRecipe[optionName].key !== 'none')          // ensure it's  not the default colour
                    && (this.curRecipe[optionName].key !== 'normal')        // ensure it's not the default dough
                ) || (
                // check if current option id is matching the condition ids
                filter.if.conditions.includes(this.curRecipe[optionName].id)
            )) {
                // enable filter
                this.$store.commit('enableFilter', {type: filter.then.optionType, id: filter.id});

                //deactivate all 'then' condition  '*' (all) matches
                if (filter.then.conditions === '*') {
                    //reset active option
                    this.resetActiveOption();
                    // hide all options
                    return [];
                } else {
                    // deactivate all not condition matching ids
                    return this.activeOptions.filter((id) => {
                        return filter.then.conditions.includes(id);
                    });
                }
            } else {
                // disable filter
                this.$store.commit('disableFilter', {type: filter.then.optionType, id: filter.id});
            }
          }
        }

        // return all active options
        return this.activeOptions;
      },

      resetActiveOption: function () {
        // make singular name
        let type = this.optionName.slice(0, -1);

        // check if option can be reset
        if('size' != type) {
          // get default option or empty option if not set in defaults
          let option = this.curRecipe.bun.defaults[type] === undefined? {}: this.curRecipe.bun.defaults[type];
          // commit option change
          this.$store.commit('selectOption', {type, option});
        }
      }
    }
  }
</script>